const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-profiles",
    meta: {},
    name: "m-profiles",
    component: () => import("@/modules/mprofiles/RootView.vue")
});

export default Routes;